export default __webpack_public_path__ + "static/media/Pedestal_Mobile.f5c86cdc.jpg";